import { ruleLanguageSpec } from "../spec/languageSpec.js";

let registered = false;

export function registerRuleLanguageMonaco(monaco) {
    if (!monaco) {
        throw new Error("Monaco instance is required");
    }
    const langId = ruleLanguageSpec.languageId;
    if (registered) return langId;

    monaco.languages.register({ id: langId });

    const operatorLexemes = ruleLanguageSpec.operators.map(o => o.lexeme);
    const escapedOps = operatorLexemes
        .map(op => op.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"))
        .sort((a, b) => b.length - a.length);

    monaco.languages.setMonarchTokensProvider(langId, {
        keywords: ruleLanguageSpec.keywords,
        operators: operatorLexemes,
        tokenizer: {
            root: [
                [new RegExp(`\\b(?:${ruleLanguageSpec.keywords.join("|")})\\b`), "keyword"],
                [/\$/, "delimiter"],
                [/`[^`]*`/, "string.escape"],
                [/%[dsb]/, "type"],
                [/%/, "delimiter"],
                [/\[/, "delimiter.square"],
                [new RegExp(`(?:${escapedOps.join("|")})`), "operator"],
                [/[(){}]/, "@brackets"],
                [/-?(?:\d+\.?\d*|\d*\.?\d+)/, "number"],
                [/[A-Za-z_][A-Za-z0-9_]*/, "identifier"],
                [/,/, "delimiter.comma"],
                [/[ \t\r\n]+/, "white"],
            ],
        },
    });

    monaco.languages.setLanguageConfiguration(langId, {
        brackets: [["{", "}"], ["[", "]"], ["(", ")"]],
        autoClosingPairs: [
            { open: "{", close: "}" },
            { open: "[", close: "]" },
            { open: "(", close: ")" },
            { open: "`", close: "`" },
        ],
        surroundingPairs: [
            { open: "{", close: "}" },
            { open: "[", close: "]" },
            { open: "(", close: ")" },
            { open: "`", close: "`" },
        ],
    });

    registered = true;
    return langId;
}
